// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/operacional/services/entregaService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import { paramsDaLista, type ListaFiltros, type PaginadoComResumo, type EntregaListaResumo } from './listaFiltros';
import type {
  EntregaResumo,
  EntregaProduto,
  EntregaDetalhe,
  AtualizarStatusEntregaRequest,
  ConferirEntregaProdutoRequest,
  FecharConferenciaEntregaRequest,
} from '../types';

const BASE = '/api/entregas';

export const entregaService = {
  async getAll(pagina = 1, tamanhoPagina = 20, filtros: ListaFiltros = {}): Promise<PaginadoComResumo<EntregaResumo, EntregaListaResumo>> {
    const { data } = await apiClient.get<PaginadoComResumo<EntregaResumo, EntregaListaResumo>>(BASE, {
      params: paramsDaLista(pagina, tamanhoPagina, filtros),
    });
    return data;
  },

  async getPendentes(): Promise<EntregaResumo[]> {
    const { data } = await apiClient.get<EntregaResumo[]>(`${BASE}/pendentes`);
    return data;
  },

  async getPorPeriodo(inicio: string, fim: string): Promise<EntregaResumo[]> {
    const { data } = await apiClient.get<EntregaResumo[]>(`${BASE}/periodo`, {
      params: { inicio, fim },
    });
    return data;
  },

  async getById(id: number): Promise<EntregaDetalhe> {
    const { data } = await apiClient.get<EntregaDetalhe>(`${BASE}/${id}`);
    return data;
  },

  async atualizarStatus(id: number, request: AtualizarStatusEntregaRequest): Promise<EntregaResumo> {
    const { data } = await apiClient.put<EntregaResumo>(`${BASE}/${id}/status`, request);
    return data;
  },

  async conferirProduto(
    id: number,
    itemId: number,
    request: ConferirEntregaProdutoRequest,
  ): Promise<EntregaProduto> {
    const { data } = await apiClient.put<EntregaProduto>(
      `${BASE}/${id}/produtos/${itemId}/conferir`,
      request,
    );
    return data;
  },

  async fecharConferencia(
    id: number,
    request: FecharConferenciaEntregaRequest = {},
  ): Promise<EntregaDetalhe> {
    const { data } = await apiClient.post<EntregaDetalhe>(`${BASE}/${id}/conferir`, request);
    return data;
  },

  async reabrirConferencia(id: number): Promise<EntregaResumo> {
    const { data } = await apiClient.put<EntregaResumo>(`${BASE}/${id}/reabrir-conferencia`, {});
    return data;
  },
};
